import React, { useState } from "react";
import { InputProps, Textarea } from "@amzn/awsui-components-react-v3";
import { FieldEditorProps } from "../../data-grid/interfaces/FieldEditorProps";

const ENTER_KEY_CODE = 13;

const FreeTextEditor = ({ currentValue, onChange }: FieldEditorProps<string>): JSX.Element => {
  const [value, setValue] = useState<string>(currentValue);

  const onEnterPress = (event: CustomEvent<InputProps.KeyDetail>): void => {
    const { keyCode, shiftKey } = event.detail;
    if (keyCode === ENTER_KEY_CODE && shiftKey === false) {
      event.stopPropagation();
      event.preventDefault();
      onChange(value);
    }
  };

  return (
    <Textarea
      onChange={({ detail }) => setValue(detail.value)}
      value={value}
      placeholder="Enter a value and hit enter to save"
      onKeyDown={onEnterPress}
    />
  );
};

export default FreeTextEditor;
